import useWorkflowStore from "@/store/workflow/workflowStore";
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const useScrollPosition = () => {
  const { workflowListScrollPosition, setWorkflowListScrollPosition } =
    useWorkflowStore();
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const restoreScrollPosition = () => {
      const positionToRestore = workflowListScrollPosition || 0;
      const listElement = document.getElementById("workflowList");
      if (listElement) {
        listElement.scrollTop = positionToRestore;
      }
    };

    // 常にスクロール位置を復元する
    restoreScrollPosition();
  }, [pathname, workflowListScrollPosition]);

  const saveScrollPosition = () => {
    try {
      const listElement = document.getElementById("workflowList");
      if (listElement) {
        const position = listElement.scrollTop;
        setWorkflowListScrollPosition(position);
      }
    } catch (error) {
      throw error;
    }
  };

  const scrollToWorkflowItem = (workflowId: string) => {
    const listElement = document.getElementById("workflowList");
    const workflowElements = document.querySelectorAll(
      `[data-workflow-id="${workflowId}"]`
    );

    if (listElement && workflowElements.length > 0) {
      const workflowElement = workflowElements[0] as Element;

      const elementRect = workflowElement.getBoundingClientRect();
      const listRect = listElement.getBoundingClientRect();

      // 要素がリストの表示領域内に収まるようにスクロール
      if (
        elementRect.top < listRect.top ||
        elementRect.bottom > listRect.bottom
      ) {
        workflowElement.scrollIntoView({ block: "center" });
        // スクロール位置を保存
        saveScrollPosition();
      }
    }
  };

  return {
    saveScrollPosition,
    scrollToWorkflowItem,
  };
};
